import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { clientCreationApi } from '../../../lib/clientCreationApi';

export default function CreateClientLink() {
  const { t } = useTranslation('admin_client_onboarding');
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    clientCreationApi.capabilities().then(data => {
      if (active) setEnabled(data.apply_enabled === true);
    }).catch(() => { /* Creation remains unavailable. */ });
    return () => { active = false; };
  }, []);
  return enabled ? <a href="/admin/clients/new"
    className="inline-flex min-h-[44px] items-center mt-3 px-4 rounded-xl bg-[var(--color-primary)] text-white">
    {t('creation.create')}
  </a> : null;
}
